import { useState, useEffect } from 'react';
import { Plus, MessageSquare, PanelLeftClose, PanelLeft } from 'lucide-react';
import { modelBuilderApi } from '../../services/modelBuilderApi';
import { chatTheme as th } from '../../theme/chat';

export function ModelBuilderThreadList({ activeThreadId, onSelectThread, onNewChat, refreshKey }) {
  const [threads, setThreads] = useState([]);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    modelBuilderApi.getThreads()
      .then(data => setThreads(data.threads || []))
      .catch(() => setThreads([]));
  }, [refreshKey]);

  const groupByDate = (threads) => {
    const today = new Date().toDateString();
    const yesterday = new Date(Date.now() - 86400000).toDateString();
    const groups = { Today: [], Yesterday: [], Earlier: [] };
    threads.forEach(t => {
      const d = new Date(t.updated_at || t.created_at).toDateString();
      if (d === today) groups.Today.push(t);
      else if (d === yesterday) groups.Yesterday.push(t);
      else groups.Earlier.push(t);
    });
    return groups;
  };

  const groups = groupByDate(threads);

  if (collapsed) {
    return (
      <div className={`${th.sidebar.bg} ${th.sidebar.border} flex flex-col items-center py-3 px-1.5`}>
        <button onClick={() => setCollapsed(false)}
          className={`p-1.5 rounded-lg transition-colors ${th.sidebar.collapseBtn}`} title="Show thread history">
          <PanelLeft className="h-5 w-5" />
        </button>
        <button onClick={onNewChat}
          className={`p-1.5 rounded-lg mt-2 transition-colors ${th.sidebar.collapseBtn}`} title="New chat">
          <Plus className="h-5 w-5" />
        </button>
      </div>
    );
  }

  return (
    <div className={`w-64 ${th.sidebar.bg} ${th.sidebar.border} flex flex-col overflow-hidden`}>
      <div className="p-3 flex items-center gap-2">
        <button onClick={onNewChat}
          className={`flex-1 flex items-center gap-2 px-3 py-2 text-sm rounded-lg transition-colors ${th.sidebar.newBtn}`}>
          <Plus className="h-4 w-4" /> New Chat
        </button>
        <button onClick={() => setCollapsed(true)}
          className={`p-1.5 rounded-lg transition-colors ${th.sidebar.collapseBtn}`} title="Hide thread history">
          <PanelLeftClose className="h-4 w-4" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto px-2 pb-2">
        {Object.entries(groups).map(([label, items]) => items.length > 0 && (
          <div key={label} className="mb-3">
            <div className={`text-xs px-2 mb-1 uppercase tracking-wider ${th.sidebar.groupLabel}`}>{label}</div>
            {items.map(t => (
              <button key={t.thread_id} onClick={() => onSelectThread(t.thread_id)}
                className={`w-full text-left flex items-center gap-2 px-2 py-1.5 text-sm rounded-lg transition-colors
                  ${activeThreadId === t.thread_id ? th.sidebar.threadActive : th.sidebar.threadInactive}`}>
                <MessageSquare className={`h-3.5 w-3.5 flex-shrink-0 opacity-50`} />
                <span className="truncate">{t.title || 'Untitled'}</span>
              </button>
            ))}
          </div>
        ))}
        {threads.length === 0 && (
          <div className={`text-center text-xs mt-8 px-4 ${th.sidebar.emptyText}`}>
            No conversations yet. Start by asking a question.
          </div>
        )}
      </div>
    </div>
  );
}
